<template>
  <div :class="[$attrs.class, currentCollapseClasses]" ref="collapse">
    <div ref="contentWrapper">
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onBeforeMount, onMounted, computed, watch, ref, nextTick } from 'vue'

  const props = defineProps({
    collapseOpen: Boolean,
    duration: Number,
  })

  const collapse = ref(null);
  const collapseState = ref('closed');
  const contentWrapper = ref(null);
  const animating = ref(false);
  const initialized = ref(false);

  onBeforeMount(() => {
    if (props.collapseOpen) { 
      collapseState.value = 'open'
    }
  })

  onMounted(() => {
    if (props.collapseOpen) {
      if (collapse.value) {
        (collapse.value! as HTMLElement).style.height = (slotHeight().toString() + 'px');

        nextTick(() => {
          (collapse.value! as HTMLElement).style.height = 'auto';
        })
      }
      animating.value = false;
    } else {
      if (collapse.value) {
        (collapse.value! as HTMLElement).style.height = ('0px')
      }
    }

    initialized.value = true;
  })

  watch(() => props.collapseOpen, (newVal, oldVal) => { 
    if (newVal != oldVal && initialized.value) {
      if (newVal) {
        toggleToOpen()
      } else {
        toggleToClose()
      }
    }
  })

  const toggleToOpen = (() => {
    if (initialized.value) {
      animating.value = true;
      if (collapse.value) {
        (collapse.value! as HTMLElement).style.height = ('0px')
      }

      collapseState.value = 'collapsing'
      nextTick(() => {
        if (collapse.value) {
          (collapse.value! as HTMLElement).style.height = (slotHeight().toString() + 'px')
        }
      })

      window.setTimeout(function() {
        collapseState.value = 'open'
        animating.value = false;
        nextTick(() => {
          (collapse.value! as HTMLElement).style.height = 'auto';
        })
      }, props.duration);
    }
  })

  const toggleToClose = (() => {
    if (initialized.value) {
      animating.value = true;
      nextTick(() => {
        if (collapse.value) {
          (collapse.value! as HTMLElement).style.height = (slotHeight().toString() + 'px')
        }

        nextTick(() => {
          window.setTimeout(function() {
          collapseState.value = 'collapsing'
            nextTick(() => {
              if (collapse.value) {
                (collapse.value! as HTMLElement).style.height = ('0px')
              }
            })
            window.setTimeout(function() {
              collapseState.value = 'closed'
              animating.value = false;
            }, props.duration!);
          },10);
        })
      })
    }
  })

  const slotHeight = (): number => {
    let height = 0;

    if (contentWrapper.value) {
      height = (contentWrapper.value as HTMLElement).clientHeight;
    }

    return height;
  }

  const currentCollapseClasses = computed(() => {
    let classes = "tw-transition-all tw-ease-in tw-duration-"+props.duration!.toString()

    switch(collapseState.value) { 
       case 'closed': { 
          classes += " tw-hidden sw-height-0 "
          break; 
       } 
       case 'collapsing': { 
          classes += " tw-relative tw-overflow-hidden "
          break; 
       }
       case 'open': {
        classes += " sw-height-auto tw-block"
        break;
       }
    }

    return classes
  }) 


</script>

